module.exports = __webpack_public_path__ + "img/red_heart.d994b4ea.png";